module.exports = __webpack_public_path__ + "static/media/landing-bg-mobile.9c2d1717.webp";